import { render, staticRenderFns } from "./FZQuestionNumSetting.vue?vue&type=template&id=7883d510&scoped=true"
import script from "./FZQuestionNumSetting.vue?vue&type=script&lang=js"
export * from "./FZQuestionNumSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7883d510",
  null
  
)

export default component.exports